export default __webpack_public_path__ + "d0355a89555540c887f42c73ab2c7d3e.png";